const _strings = {
  no_options: {
    'ar-SA': 'لم يتم العثور على نتائج.',
    'cs-CZ': 'Nebyly Nalezeny Žádné Výsledky.',
    'de-DE': 'Keine Ergebnisse gefunden.',
    'en-AU': 'No results found.',
    'en-CA': 'No results found.',
    'en-GB': 'No results found.',
    'en-SG': 'No results found.',
    'en-US': 'No results found.',
    'es-ES': 'No se han encontrado resultados.',
    'es-MX': 'No se encontraron resultados',
    'fr-CA': 'Aucun résultat trouvé.',
    'fr-FR': 'Aucun résultat trouvé.',
    'hi-IN': 'कोई परिणाम नहीं मिला.',
    'hu-HU': 'Nincsenek találatok.',
    'it-IT': 'Nessun risultato.',
    'ja-JP': '何も見つかりませんでした。',
    'lt-LT': 'Rezultatų nerasta.',
    'my-MM': 'ရလဒ်မတွေ့ပါ။',
    'ne-NP': 'कुनै नतिजाहरू फेला परेनन्।',
    'pl-PL': 'Nie znaleziono żadnych wyników.',
    'pt-BR': 'Nenhum resultado encontrado.',
    'ro-RO': 'Niciun rezultat găsit.',
    'ru-RU': 'Результаты не найдены.',
    'sk-SK': 'Nenašli sa žiadne výsledky.',
    'so-SO': 'Natiijada lama helin.',
    'tl-PH': 'Walang nahanap na resulta.',
    'tr-TR': 'Sonuç bulunamadı.',
    'uk-UA': 'Нічого не знайдено.',
    'ur-PK': 'کوئی نتیجہ نہیں ملا۔',
    'vi-VN': 'Không tìm thấy kết quả nào.',
    'zh-CN': '未找到任何结果。',
  },
};

module.exports = _strings;
